export default __webpack_public_path__ + "static/key-brain--pink-4ddcb0cac117bf32046c97ec4a4b3944.webp";